// extracted by mini-css-extract-plugin
export default {"expert-team":"expertteam_expert-team__oxWnh","teams":"expertteam_teams__KLEnR"};